export default {
  products: [
    {
      name: 'fiber500',
      heading: 'Fiber 500',
      legal: 'Per month for 24 months with Auto Pay. One-time charges may apply. Max speeds are wired and location dependent. Wi-Fi, actual & average speeds vary.',
      valueProps: {
        heading: 'Boost your business',
        items: [
          '$5/mo. discount with Auto Pay',
          'Waived Installation Fee ($95 value)'
        ]
      }
    },
    {
      name: 'fiberGig',
      heading: 'Fiber 1 Gig',
      legal: 'Per month for 24 months with Auto Pay. One-time charges may apply. Max speeds are wired and location dependent. Wi-Fi, actual & average speeds vary.',
      valueProps: {
        heading: 'Upgrade your network',
        items: [
          'Our most popular plan',
          'Waived Installation Fee ($95 value)'
        ]
      }
    },
    {
      name: 'fiber2Gig',
      heading: 'Fiber 2 Gig',
      legal: 'Per month for 24 months with Auto Pay. One-time charges may apply. Max speeds are wired and location dependent. Wi-Fi, actual & average speeds vary.',
      valueProps: {
        heading: 'Get faster, more advanced performance',
        items: [
          'Waived Installation Fee ($95 value)'
        ]
      }
    },
    {
      name: 'fiber5Gig',
      heading: 'Fiber 5 Gig',
      legal: 'Per month for 24 months with Auto Pay. One-time charges may apply. Max speeds are wired and location dependent. Wi-Fi, actual & average speeds vary.',
      valueProps: {
        heading: 'Go further with extremely fast speeds',
        items: [
          'Advanced audio, streaming and collaboration capabilities',
          'Expert installation and waived fee ($95 value)'
        ]
      }
    },
    {
      name: 'fiber7Gig',
      heading: 'Fiber 7 Gig Ultra',
      legal: 'Per month for 24 months with Auto Pay. One-time charges may apply. Max speeds are wired and location dependent. Wi-Fi, actual & average speeds vary.',
      valueProps: {
        heading: 'Do more with industry-leading speeds',
        items: [
          'Our fastest, highest-performing speed',
          'Bundled with online protection, priority on-site repair, and seamless backup solutions',
          'Expert installation and waived fee ($95 value)'
        ]
      }
    }
  ]
};
